<script setup lang="ts">
const platform = useState('platform')

const config = useRuntimeConfig()
const searchTerm = ref('')
const searchTermDebounced = refDebounced(searchTerm, 200)
const selectedLocation = ref(null)
watch(selectedLocation, async (newValue) => {
  if (newValue) {
    await navigateTo({ path: '/recherche', query: {coordinates: newValue.coordinates, value: newValue.value}})
  }
})

if (!useSiteConfig().platform.settings.home) {
  await navigateTo({ path: '/recherche'})
}

const home = computed(() => platform.value?.settings?.homeV2 ?? platform.value?.settings?.home)
</script>

<template>
  <UPageHero
      class="dark bg-primary"
      :class="{
        'min-h-[calc(100vh-var(--ui-header-height))]': !platform?.thumbnails.length,
        'min-h-[calc(60vh-var(--ui-header-height))]': platform?.thumbnails.length
      }"
      orientation="horizontal"
      :ui="{
        container: 'pb-0 sm:pb-0 lg:py-0',
        description: 'text-balance',
        title: 'sm:text-base text-base'
      }"
  >
    <img :src="`https://www.${useBenevoltDomain()}/assets/im/platform/${platform.slug}-cover.jpg`"
         alt=""
         class="absolute inset-0 -z-20 h-full w-full object-cover object-center" />
    <div class="absolute inset-0 -z-10 opacity-30 bg-black"></div>
    <template #title v-if="home?.title">
      <Markdown :value="home?.title" unwrap="p" class="text-shadow-md" />
    </template>
    <template #description v-if="home?.description">
      <Markdown :value="home?.description" unwrap="p" class="text-white text-shadow-md"/>
    </template>

    <div class="p-4 lg:px-16 lg:py-48">
      <UCard class="light " :ui="{body: 'space-y-4'}">
        <Markdown :value="home?.searchTitle ?? '[Devenir bénévole]{.font-bold} :br près de chez vous'" unwrap="p" class="text-3xl text-center font-semibold text-(--ui-primary)" />
        <InputNeighborhood v-if="platform.type === 'city'" v-model="selectedLocation" class="w-full" size="lg" />
        <InputCity v-else v-model="selectedLocation" :types="['place', 'locality', 'postcode']" class="w-full" size="lg" />
        <UButton size="lg" icon="i-ph-magnifying-glass" block to="/recherche">Rechercher</UButton>
      </UCard>
    </div>

  </UPageHero>
  <UContainer class="py-12" v-if="platform?.thumbnails.length">
    <div class="flex flex-wrap justify-center gap-8">
      <UBlogPost v-for="thumbnail in platform?.thumbnails" :title="thumbnail.title" :description="thumbnail.text" :image="thumbnail.cover" :to="thumbnail.url" :target="thumbnail.newtab ? '_blank' : null" :ui="{footer: 'px-4 pb-4 sm:px-6 sm:pb-6'}" class="w-full sm:w-[calc((100%-2rem)/2)] lg:w-[calc((100%-4rem)/3)]">
        <template #footer>
          <UButton block :label="thumbnail.cta" v-if="thumbnail.cta" size="xl" />
        </template>
      </UBlogPost>
    </div>
  </UContainer>
</template>